import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const RmaNumber = {
  id: 'rmaNumber',
  displayName: <FormattedMessage {...messages.rmaNumber} />,
  type: OptionFormTypes.TYPE_CONTAINS,
  filterValue: 'rmaNumber',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CONTAINS, criteriaInformations);
  },
};
